import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function Login({ mode }: { mode: "login" | "register" }) {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") ?? "/dashboard";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (mode === "register") await register(email, password, name);
      else await login(email, password);
      navigate(next);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="form" onSubmit={submit} data-testid="auth-form">
      <h1 className="center">{mode === "register" ? "Create your account" : "Welcome back"}</h1>
      <p className="center muted" style={{ marginBottom: 24 }}>
        {mode === "register" ? "Start deploying servers in minutes." : "Sign in to manage your servers."}
      </p>
      {error && <div className="error-box" data-testid="auth-error">{error}</div>}
      {mode === "register" && (
        <div className="field">
          <label>Name</label>
          <input className="input" value={name} onChange={(e) => setName(e.target.value)} data-testid="name" />
        </div>
      )}
      <div className="field">
        <label>Email</label>
        <input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="email" />
      </div>
      <div className="field">
        <label>Password</label>
        <input className="input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="password" />
      </div>
      <button className="btn btn-primary" style={{ width: "100%" }} disabled={busy} data-testid="submit">
        {busy ? "…" : mode === "register" ? "Create account" : "Sign in"}
      </button>
      <p className="center muted mt">
        {mode === "register" ? (
          <>Already have an account? <Link to="/login">Sign in</Link></>
        ) : (
          <>New here? <Link to="/register">Create an account</Link></>
        )}
      </p>
    </form>
  );
}
